export default __webpack_public_path__ + "static/media/border.e9b34e6d.jpg";